import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-msg',
  templateUrl: './modal-msg.component.html',
  styleUrls: ['./modal-msg.component.css']
})
export class ModalMsgComponent implements OnInit {
  @Input() padre: string;
  @Input() titulo: string;
  @Input() texto: string;
  @Input() check: number;
  @Input() label: string;

  etiqueta: string = 'Volver';

  constructor( 
    public activeModal: NgbActiveModal,
    private router: Router
  ) { }

  ngOnInit(): void {
    if(this.label !== null || this.label !== undefined){
      this.etiqueta = this.label;
    }
  }

  salir(){
    this.activeModal.dismiss('Cross click');
    if(this.padre !== null && this.padre !== undefined){
      if(this.padre ==='perfil-pendiente') {
        this.router.navigate(['/', 'admin', 'agencias-pendientes']);
      } else if(this.padre ==='perfil'){        
        this.router.navigate(['/', 'admin', 'agencias']);
      }else if(this.padre == 'viajes'){
        this.router.navigate(['/', 'admin', 'packs']);
      }
    } 
    
    
  }

}
